import React from 'react';
import './App.css';
import MapBetweenPlaces from './MapBetweenPlaces.tsx';

function App() {
  return (
    <div className="App">
      <MapBetweenPlaces />
    </div>
  );
}

export default App;
